import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { time } from "./encryption";
import "./assets/reset.css";
import "./assets/quill.css";
import vant from "@/vant/config.js";
import echarts from "echarts";
import ViewUI from "view-design";
// import BaiduMap from "vue-baidu-map";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Field,Form,Button,Icon,Step, Steps, RadioGroup, Radio,Checkbox, CheckboxGroup,Stepper, DatetimePicker, Area, List, Image as VanImage, Overlay  } from 'vant';
import { Dialog,Toast,Popup,Picker} from 'vant';
import { Cell, CellGroup } from 'vant';
import { Uploader,Calendar } from 'vant';
import compressiImg from './api/compressiImg'


Vue.prototype.$api = compressiImg;
Vue.use(Uploader);
import "./assets/font/zhenyan.css" 

Vue.config.productionTip = false;

Vue.use(Dialog).use(Toast);

Vue.use(Field).use(Form).use(Button)
Vue.use(Step);
Vue.use(Calendar);
Vue.use(Steps);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Icon).use(Stepper);
Vue.use(Picker).use(Popup)
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(DatetimePicker);
Vue.use(Area);
Vue.use(List);
Vue.use(VanImage);
Vue.use(Overlay);
//兼容问题
Vue.use(ViewUI, {
  i18n: function (path, options) {
    let value = i18n.t(path, options);
    if (value !== null && value !== undefined) return value;
    return '';
  }
});
Vue.config.productionTip = false;
Vue.use(ElementUI);
//使用echarts
Vue.prototype.$echarts = echarts;

Vue.use(vant);
// Vue.use(BaiduMap, {
//   ak: "N31Z8c7fTmiaueIyIiFQR4VGZHfb8h5s",
// });

//生成当前时间毫秒数
Vue.prototype.time = time;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
